export const HOME_LOGIN_SCREEN_STATUS            = "login_screen_status";
export const HOME_DASHBOARD_SCREEN_STATUS        = "dashboard_screen_status";

export const ADMIN_SCREEN_STATUS                  = "admin_screen_status";

/*Catalogs*/
export const MERCHANT_CRUD_SCREEN_STATUS              = "merchant_crud_fragment";
export const MERCHANT_PRODUCT_CRUD_SCREEN_STATUS      = "merchant_product_crud_fragment";
export const ECOSYSTEM_DEVICE_CRUD_SCREEN_STATUS      = "ecosystem_device_crud_fragment";
export const SERVICE_TABLE_CRUD_SCREEN_STATUS              = "service_table_crud_fragment";
export const SERVICE_SEQUENCE_CRUD_SCREEN_STATUS              = "service_sequence_crud_fragment";
export const CHECKIN_PROJECT_CRUD_SCREEN_STATUS              = "checkin_project_crud_fragment";
export const CHECKIN_ZONE_CRUD_SCREEN_STATUS              = "checkin_zone_crud_fragment";
export const GATEWAY_PASSAGE_CRUD_SCREEN_STATUS              = "gateway_passage_crud_fragment";

/*Assignment*/
export const ASSIGN_POS_SCREEN_STATUS = "assign_pos_fragment";                      
export const REASSIGN_POS_SCREEN_STATUS = "reassign_pos_fragment";                      
export const ASSIGN_DEPOSIT_SCREEN_STATUS = "assign_deposit_fragment";                      
export const REASSIGN_DEPOSIT_SCREEN_STATUS = "reassign_deposit_fragment";
export const ASSIGN_STAFF_NAME_SCREEN_STATUS = "assign_staff_name_fragment";
export const ASSIGNED_LIST_USER_SCREEN_STATUS = "assigned_list_user_fragment";  


/*Assignment Ecosystem*/
export const ASSIGN_POS_ECOSYSTEM_SCREEN_STATUS = "assign_pos_ecosystem_fragment";                      
export const REASSIGN_POS_ECOSYSTEM_SCREEN_STATUS = "reassign_pos_ecosystem_fragment";                      
export const ASSIGN_DEPOSIT_ECOSYSTEM_SCREEN_STATUS = "assign_deposit_ecosystem_fragment";                      
export const REASSIGN_DEPOSIT_ECOSYSTEM_SCREEN_STATUS = "reassign_deposit_ecosystem_fragment";
export const ASSIGN_GATEWAY_ECOSYSTEM_SCREEN_STATUS = "assign_gateway_ecosystem_fragment";                      
export const REASSIGN_GATEWAY_ECOSYSTEM_SCREEN_STATUS = "reassign_gateway_ecosystem_fragment";                      
export const ASSIGN_SUPERVISOR_ECOSYSTEM_SCREEN_STATUS = "assign_supervisor_ecosystem_fragment";                      
export const REASSIGN_SUPERVISOR_ECOSYSTEM_SCREEN_STATUS = "reassign_supervisor_ecosystem_fragment";        
export const ASSIGN_BRAND_ACTIVATION_ECOSYSTEM_SCREEN_STATUS = "assign_brand_activation_ecosystem_fragment";                      
export const REASSIGN_BRAND_ACTIVATION_ECOSYSTEM_SCREEN_STATUS = "reassign_brand_activation_ecosystem_fragment";                                    
export const ASSIGN_SERVICE_ORDER_ECOSYSTEM_SCREEN_STATUS = "assign_service_order_ecosystem_fragment";                      
export const REASSIGN_SERVICE_ORDER_ECOSYSTEM_SCREEN_STATUS = "reassign_service_order_ecosystem_fragment";                                    
export const ASSIGN_STAFF_NAME_ECOSYSTEM_SCREEN_STATUS = "assign_staff_name_ecosystem_fragment";
//export const ASSIGNED_LIST_USER_ECOSYSTEM_SCREEN_STATUS = "assigned_list_user_ecosystem_fragment";  

/*Reports*/
export const CLIENT_ACCOUNT_BALANCE_REPORT_SCREEN = "client_account_balance_Report_screen";
export const DEPOSIT_SUMMARY_REPORT_SCREEN = "deposit_summary_report_screen";
export const DEPOSIT_SUMMARY_CUTOFF_REPORT_SCREEN = "deposit_summary_cutoff_report_screen";
export const GATEWAY_SUMMARY_REPORT_SCREEN = "gateway_summary_report_screen";
export const GATEWAY_SUMMARY_CUTOFF_REPORT_SCREEN = "gateway_summary_cutoff_report_screen";
export const MERCHANT_SUMMARY_REPORT_SCREEN = "merchant_summary_report_screen";
export const MERCHANT_SUMMARY_CUTOFF_REPORT_SCREEN = "merchant_summary_cutoff_report_screen";
export const STAFF_CUTOFF_REPORT_SCREEN = "staff_cutoff_report_screen";

/*Registry*/
export const CREATE_CLIENT_ACCOUNT= "create_client_account";
export const CREATE_ENROLLED_CLIENT_ACCOUNT= "create_enrolled_client_account";
export const ACTIVATE_CLIENT_ACCOUNT= "activate_client_account";
export const ACTIVATE_ENROLLED_CLIENT_ACCOUNT= "activate_enrolled_client_account";
export const ACTIVATE_ENROLLED_CLIENT_ACCOUNT_NAME= "activate_enrolled_client_account_name";
export const ACTIVATE_ENROLLED_CLIENT_ACCOUNT_QR= "activate_enrolled_client_account_QR";
export const CREATE_STAFF_USER= "create_staff_user";

/*Conventions*/
export const CONVENTION_CRUD_SCREEN_STATUS = "convention_crud_fragment";
export const CONFERENCE_CRUD_SCREEN_STATUS = "conference_crud_fragment";
export const EXPOSITOR_CRUD_SCREEN_STATUS = "expositor_crud_fragment";
export const CONFERENCE_GUEST_CRUD_SCREEN_STATUS = "conference_guest_crud_fragment";



/*Setup*/
export const CLIENT_ACCOUNT_UPLOAD_SCREEN = "client_account_upload_screen";
export const ENROLLED_CLIENT_ACCOUNT_UPLOAD_SCREEN = "enrolled_client_account_upload_screen";
export const CONFERENCE_GUEST_UPLOAD_SCREEN = "conference_guest_upload_screen";
export const SUBSYSTEM_REBOOT_SCREEN = "subsystem_reboot_screen";

export const ADMIN_MENU_FRAGMENT            = "admin_menu_fragment";


